import $ from 'jquery'

function header () {
  $('#nav-toggle').on('click', function (e) {
    e.preventDefault()
    $('body').toggleClass('header-active')
  })

  $('.header-nav__link--submenu').each(function () {
    const block = $(this)
    const btn = $(this)
    const subNav = $(this).next()
    const closeBtn = subNav.find('.header-subnav__close');
    btn.on('click', function (e) {
      if( $(window).width() > 991 ) return;
      e.preventDefault()
      subNav.toggleClass('active');
    })
    closeBtn.on('click', function (e) {
      if( $(window).width() > 991 ) return;
      e.preventDefault()
      subNav.removeClass('active');
    })
  })

  $('.solution-nav').each(function () {
    const block = $(this)
    const btn = $(this).find('.solution-nav__header');
    const menu = $(this).next()
    btn.on('click', function (e) {
      if( $(window).width() > 991 ) return;
      e.preventDefault()
      block.toggleClass('nav-active')
    })
    block.find('.solution-nav__link').on('click', function (e) {
      if( $(window).width() > 991 ) return;
      block.removeClass('nav-active')
    })
  })

  $('.footer-accordion').each(function () {
    const block = $(this)
    const btn = $(this).find('.footer-accordion-btn');
    const content = $(this).find('.footer-accordion-content');
    btn.on('click', function (e) {
      if( $(window).width() > 991 ) return;
      e.preventDefault()
      content.slideToggle()
      block.toggleClass('active')
    })
  })


  // header hide on scrolling
  // Hide Header on on scroll down
  let didScroll
  let lastScrollTop = 0
  const delta = 5

  $(window).scroll(function (event) {
    didScroll = true
  })

  setInterval(function () {
    if (didScroll) {
      hasScrolled()
      didScroll = false
    }
  }, 50)

  function hasScrolled () {
    const st = $(document).scrollTop()

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) { return }

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > 300) {
      // Scroll Down
      $('body').removeClass('nav-down').addClass('nav-up')
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $('body').removeClass('nav-up').addClass('nav-down')
      }
    }
    lastScrollTop = st
  }

  // header info bar
  function setCookie (name, value, days) {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
  }

  function getCookie (name) {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return false
  }

  const headerInfoBar = $('.header__info-bar')
  const headerInfoBarClose = $('.header__info-bar__close')
  if (headerInfoBar.length && !getCookie('header-bar')) {
    headerInfoBar.removeClass('header__info-bar--closed')
  }
  headerInfoBarClose.click(function () {
    headerInfoBar.slideUp(function () {
      headerInfoBar.addClass('header__info-bar--closed')
    })
    setCookie('header-bar', true, 3)
  })
}

export { header }
